import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRight, Loader2, Sparkles } from 'lucide-react';
import { studioApi } from '@/lib/studioApi';
import '@/styles/quickstart.css';

// Landing page behind a shared WhatsApp link: the design on the product + "Selbst gestalten" (no price).
export default function SharePage() {
  const { id } = useParams(), [data, setData] = useState(null), [error, setError] = useState('');
  useEffect(() => { studioApi(`/share/${id}`).then(setData).catch(e => setError(e.message)); }, [id]);
  return <main className="qs-shell qs-share" data-testid="share-page">
    {error ? <p className="qs-lead" data-testid="share-error">{error}</p> : !data ? <p className="qs-detect is-busy"><Loader2 size={16} className="spin" />Design wird geladen …</p> : <>
      <p className="qs-kicker"><Sparkles size={15} />Selbst gestaltet</p>
      <h1>Schau mal – {data.product_name ? `mein Design für ${data.product_name}` : 'mein Design'}!</h1>
      <img src={`${process.env.REACT_APP_BACKEND_URL}${data.image}`} alt="Geteiltes Design" className="qs-share-img" data-testid="share-image" />
      <p className="qs-lead">In wenigen Klicks vom eigenen Foto zum persönlichen Geschenk – probier es auch aus.</p>
      <Link to="/gestalten" className="qs-next qs-share-cta" data-testid="share-cta">Selbst gestalten<ArrowRight size={17} /></Link>
    </>}
  </main>;
}
